export enum ExpenseTab {
  UPLOADED = 'UPLOADED',
  RECURRENT = 'RECURRENT',
  TO_REVIEW = 'TO_REVIEW',
}
